var _style, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBabaIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 881.2 881.2",
    style: {
      enableBackground: "new 0 0 881.2 881.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FF6B00;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 440.6,
    cy: 440.6,
    r: 440.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M89,538.1v-195h78.1c14.3,0,26.3,2.1,35.9,6.4c9.6,4.3,16.8,10.1,21.6,17.7s7.2,16.2,7.2,26 c0,7.6-1.5,14.3-4.6,20c-3,5.7-7.2,10.4-12.5,14.1c-5.3,3.7-11.3,6.2-18.1,7.8v1.9c7.4,0.3,14.4,2.4,20.9,6.3 c6.5,3.9,11.8,9.3,15.9,16.2c4.1,7,6.1,15.2,6.1,24.8c0,10.3-2.6,19.6-7.7,27.7c-5.1,8.1-12.7,14.5-22.6,19.2 c-10,4.7-22.3,7-36.9,7H89z M130.2,424.7h30.6c5.7,0,10.7-1,15.1-3c4.4-2,7.9-4.8,10.5-8.5c2.6-3.7,3.9-8.1,3.9-13.2 c0-7-2.5-12.7-7.5-17c-5-4.3-12-6.5-21.2-6.5h-31.3V424.7z M130.2,504.4h33.6c11.5,0,19.9-2.2,25.1-6.6c5.3-4.4,7.9-10.3,7.9-17.7 c0-5.4-1.3-10.2-3.9-14.3c-2.6-4.1-6.3-7.4-11.1-9.7c-4.8-2.3-10.5-3.5-17.1-3.5h-34.6V504.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M290.2,538.1H246l67.3-195h53.1l67.2,195h-44.2l-48.9-150.5h-1.5L290.2,538.1z M287.4,461.5h104.4v32.2H287.4 V461.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M447.5,538.1v-195h78.1c14.3,0,26.3,2.1,35.9,6.4c9.6,4.3,16.8,10.1,21.6,17.7s7.2,16.2,7.2,26 c0,7.6-1.5,14.3-4.6,20c-3,5.7-7.2,10.4-12.5,14.1c-5.3,3.7-11.3,6.2-18.1,7.8v1.9c7.4,0.3,14.4,2.4,20.9,6.3 c6.5,3.9,11.8,9.3,15.9,16.2c4.1,7,6.1,15.2,6.1,24.8c0,10.3-2.6,19.6-7.7,27.7c-5.1,8.1-12.7,14.5-22.6,19.2 c-10,4.7-22.3,7-36.9,7H447.5z M488.7,424.7h30.6c5.7,0,10.7-1,15.1-3c4.4-2,7.9-4.8,10.5-8.5c2.6-3.7,3.9-8.1,3.9-13.2 c0-7-2.5-12.7-7.5-17c-5-4.3-12-6.5-21.2-6.5h-31.3V424.7z M488.7,504.4h33.6c11.5,0,19.9-2.2,25.1-6.6c5.3-4.4,7.9-10.3,7.9-17.7 c0-5.4-1.3-10.2-3.9-14.3c-2.6-4.1-6.3-7.4-11.1-9.7c-4.8-2.3-10.5-3.5-17.1-3.5h-34.6V504.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M648.7,538.1h-44.2l67.3-195H725l67.2,195H748l-48.9-150.5h-1.5L648.7,538.1z M645.9,461.5h104.4v32.2H645.9 V461.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBabaIcon);
export default __webpack_public_path__ + "static/media/baba_icon.5e886925cbb15d33c256de70dd2109ce.svg";
export { ForwardRef as ReactComponent };